module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "shortcut"
  }, [_c('div', {
    staticClass: "w"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "s-right"
  }, [_c('li', {
    staticClass: "s-item fore1"
  }, [_c('a', {
    staticClass: "link-user",
    attrs: {
      "href": "//home.jd.com/",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.userName))])]), _vm._v(" "), _c('li', {
    staticClass: "s-div"
  }, [_vm._v("|")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showOrderList),
      expression: "showOrderList"
    }],
    staticClass: "s-item fore2"
  }, [_c('a', {
    staticClass: "op-i-ext",
    attrs: {
      "href": "/member/order?status=-1",
      "target": "_blank"
    }
  }, [_vm._v("我的订单")])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showOrderList),
      expression: "!showOrderList"
    }],
    staticClass: "s-item fore2"
  }, [_c('a', {
    staticClass: "op-i-ext",
    attrs: {
      "href": "/account-center",
      "target": "_blank"
    }
  }, [_vm._v("我的账户")])]), _vm._v(" "), _c('li', {
    staticClass: "s-div"
  }, [_vm._v("|")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('span', {
    staticClass: "clr"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "w"
  }, [_c('div', {
    staticClass: "order clearfix order-init order-init-oldUser-noQrcode"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showOrderList),
      expression: "showOrderList"
    }],
    staticClass: "o-left"
  }, [_c('h3', {
    staticClass: "o-title"
  }, [_vm._v("订单提交成功，请尽快付款！订单号：" + _vm._s(_vm.orderList))]), _vm._v(" "), _c('p', {
    staticClass: "o-tips"
  })]), _vm._v(" "), _c('div', {
    staticClass: "o-right"
  }, [_c('div', {
    staticClass: "o-price"
  }, [_c('em', [_vm._v("应付金额")]), _c('strong', [_vm._v(_vm._s(_vm.totalAmount))]), _c('em', [_vm._v("元")])])]), _vm._v(" "), _c('div', {
    staticClass: "o-list j_orderList",
    attrs: {
      "id": "listPayOrderInfo"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "payment"
  }, [_c('div', {
    staticClass: "pay-weixin"
  }, [_c('div', {
    staticClass: "p-w-hd"
  }, [_vm._v("支付宝支付")]), _vm._v(" "), _c('div', {
    staticClass: "p-w-bd",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "j_weixinInfo",
    staticStyle: {
      "position": "absolute",
      "top": "-36px",
      "left": "130px"
    }
  }, [_vm._v("距离二维码过期还剩"), _c('span', {
    staticClass: "j_qrCodeCountdown font-bold font-red"
  }, [_vm._v(_vm._s(_vm.count))]), _vm._v("秒，过期后请重新获取二维码。")]), _vm._v(" "), _c('div', {
    staticClass: "p-w-box"
  }, [_c('div', {
    staticClass: "pw-box-hd"
  }, [_c('div', {
    ref: "qrCodeUrl",
    staticClass: "qrcode",
    attrs: {
      "id": "weixinImageUrl"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pw-error j_weixiError"
  }), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "p-w-sidebar"
  })])]), _vm._v(" "), _vm._m(3)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "s-logo",
    attrs: {
      "href": "/home"
    }
  }, [_c('img', {
    attrs: {
      "width": "auto",
      "height": "38",
      "alt": "开心云商",
      "src": require("../../../assets/images/account_logo.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "s-item fore3"
  }, [_c('a', {
    staticClass: "op-i-ext",
    attrs: {
      "target": "_blank",
      "href": "/help"
    }
  }, [_vm._v("支付帮助")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pw-box-ft"
  }, [_c('p', [_vm._v("请使用支付宝扫一扫")]), _vm._v(" "), _c('p', [_vm._v("扫描二维码支付")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "payment-change",
    attrs: {
      "id": "return_weixin_jd"
    }
  }, [_c('a', {
    staticClass: "pc-wrap",
    attrs: {
      "onclick": "window.history.go(-1)"
    }
  }, [_c('i', {
    staticClass: "pc-w-arrow-left"
  }, [_vm._v("<")]), _vm._v(" "), _c('strong', [_vm._v("选择其他支付方式")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7055bc74"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/member-center/right/aliPage.vue
// module id = 1634
// module chunks = 1